var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2Versn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 17,
    transform: "rotate(25.3878 32 32)",
    stroke: "#D9D9D9",
    strokeWidth: 14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3911 4.9891C40.8647 3.99121 42.0575 3.56616 43.0554 4.03974L45.7657 5.32596C46.7636 5.79954 47.1886 6.9924 46.7151 7.9903L44.5714 12.5074L38.2474 9.50624L40.3911 4.9891Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75469 17.3309C6.22826 16.333 7.42113 15.908 8.41902 16.3815L12.9362 18.5252L9.93496 24.8492L5.41783 22.7055C4.41993 22.2319 3.99488 21.0391 4.46846 20.0412L5.75469 17.3309Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4938 38.2473L59.0109 40.391C60.0088 40.8646 60.4339 42.0575 59.9603 43.0554L58.6741 45.7656C58.2005 46.7635 57.0076 47.1886 56.0097 46.715L51.4926 44.5713L54.4938 38.2473Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5434 20.9211L57.4073 19.2503C58.452 18.8915 59.5897 19.4474 59.9486 20.4921L60.9697 23.4645C61.3285 24.5091 60.7726 25.6469 59.7279 26.0057L54.864 27.6765L52.5434 20.9211Z",
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2072 6.68375C18.8483 5.6391 19.4043 4.50133 20.4489 4.14248L23.4213 3.12143C24.4659 2.76257 25.6037 3.31852 25.9625 4.36318L27.6334 9.22706L20.878 11.5476L19.2072 6.68375Z",
    fill: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.07823 40.67C2.71938 39.6253 3.27533 38.4875 4.31998 38.1287L9.18387 36.4579L11.5044 43.2133L6.64055 44.8841C5.5959 45.2429 4.45813 44.687 4.09928 43.6423L3.07823 40.67Z",
    fill: "#D9D9D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8228 54.0469L43.5782 51.7263L45.2491 56.5902C45.6079 57.6348 45.052 58.7726 44.0073 59.1315L41.0349 60.1525C39.9903 60.5114 38.8525 59.9554 38.4937 58.9108L36.8228 54.0469Z",
    fill: "#D9D9D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5252 51.0638L24.8492 54.065L22.7055 58.5822C22.2319 59.5801 21.0391 60.0051 20.0412 59.5315L17.3309 58.2453C16.333 57.7717 15.9079 56.5789 16.3815 55.581L18.5252 51.0638Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Versn);
export default __webpack_public_path__ + "static/media/2versn.cc2f433c9d3fff3ece2bcfd13391f10e.svg";
export { ForwardRef as ReactComponent };